import {Injectable} from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AppService {

  constructor(
    private http: HttpClient,
    private localStorage: LocalStorageService, 
    private sessionStorage: SessionStorageService
  ) {}

  getAllResource() {
    return this.http.get(environment.urlBackEnd + 'res/all');
  }
  getProducts(body) {
    return this.http.post(environment.urlBackEnd + 'res/products/filter', body);
  }
}
